<div class="dane-obiektu select-text" *ngIf="obiekt">
  <div>
    <div *ngFor="let opis of obiekt.opisy" class="mt-2">
      <span class="naglowek-e" *ngIf="opis.label.length > 0  && opis.wartosc.length > 0">{{opis.label}}</span>
      <span *ngIf="opis.label.length > 0 && opis.wartosc.length > 0">: </span> <span class="tekst-c"
        [class.naglowek-e-info-window]="opis.label.length === 0" [mmFormatowanieInformacjiOObiekcie]="opis.wartosc"
        dozwoloneTagiHtml="a,img,br,p,b,span"></span>
    </div>

  </div>
</div>
<div *ngIf="obiekt!.uuid_mapy">
  <div tabindex="0" class="wynik duzy-font cursor-pointer info-link" (keyup.enter)="przekierujMape(obiekt?.uuid_mapy)"
    (click)="przekierujMape(obiekt?.uuid_mapy)">
    {{obiekt?.tytulWarstwy | wyborTlumaczenia:aktualnyJezyk}} -
    {{'codes.modul-mapowy.przegladanie-obiektow.przejdz-do-tematu' |
    translate}}
  </div>
</div>
<div *ngIf="obiekt!.idObiektu">
  <div tabindex="0" class="wynik duzy-font cursor-pointer info-link mt-3 mb-3" (keyup.enter)="przekierujObiektNaMape(obiekt!)"
    (click)="przekierujObiektNaMape(obiekt!)">
    {{obiekt?.tytul}} - {{'codes.modul-mapowy.przegladanie-obiektow.wyswietl-w-temacie' |
    translate}} "{{obiekt?.tytulWarstwy | wyborTlumaczenia:aktualnyJezyk}}"
  </div>
</div>
<div *ngIf="obiekt!.opisy.length===0&&!obiekt?.uuid_mapy&&!obiekt?.idObiektu" class="tekst-d">
  <mm-under-construction></mm-under-construction>
</div>
